// extracted by mini-css-extract-plugin
export var closeButton = "_ge-2";
export var closeButtonIcon = "_ge-3";
export var lightboxContent = "_ge-1";
export var lightboxOverlay = "_ge-0";